import React, { Fragment } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles((theme) => ({
  ringLoading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
    height: 100,
    borderRadius: 75,
    borderWidth: 15,
    borderColor: theme.palette.grey[200],
    borderStyle: 'solid',
  },
  metricLoading: {
    width: 40,
    borderRadius: 9,
  },
}))

const PercentageMetricLoading = () => {
  const styles = useStyles()
  return (
    <Fragment>
      <Box className={styles.ringLoading}>
        <Typography variant="h6">
          <Skeleton className={styles.metricLoading} />
        </Typography>
      </Box>
      <Box
        className={styles.subMetricLoading}
        mt={4}
      >
        <Typography variant="h6">
          <Skeleton className={styles.subMetricLoading} />
        </Typography>
      </Box>
    </Fragment>
  )
}

export default PercentageMetricLoading
